import { HttpHeaders } from "@angular/common/http";
import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { lastValueFrom, takeUntil, Subject } from "rxjs";
import { AuthService } from "src/app/core/services/AuthService";
import { DownloadService } from "src/app/core/services/download.service";
import { LoteService } from "src/app/core/services/lote.service";
import { TableAction } from "src/app/shared/components/table-paginator/table-paginator.component";
import { k } from "src/environments/properties";




interface Item {
  id: string;
  createdAt?: string;
  updatedAt: string;
  titulo: string;
  total_documentos: string;
  es_grupo: string;
  estado: string;
  firma_por_plantilla: string;
  notificacion_firmantes: string;
  plantilla_nombre: string;
  usuario: string;
}

@Component({
  selector: 'app-documentos-por-firmar',
  templateUrl: './ultimos-lotes-completados.component.html',
  styleUrls: ['./ultimos-lotes-completados.component.scss']
})
export class UltimosLotesCompletadosComponent implements OnInit {


  @ViewChild('modalDescargaDocumento') modalDescargaDocumento!: TemplateRef<any>;


  fullData: Item[] = []; // Tu conjunto completo de datos
  currentItems: Item[] = []; // Los datos para la página actual
  private destroy$ = new Subject<void>();

  lotesPorFirmar: any[] = [];
  totalItemsLotesPorFirmar: any = 0;

  public formSearch: FormGroup;

  currentPage: number = 1;
  pageSize: number = 10; // Tamaño de página inicial
  totalItems: number = 0;
  spinner: boolean;

  userToken: string = '';
  userId: any;

  loteSelected: any;

  idLoteCompleto: string;

  tableHeaders = [
    { key: 'titulo', label: 'Titulo' },
    { key: 'estado', label: 'Estado' },
    { key: 'total_documentos', label: 'Total documentos' },
    { key: 'es_grupo', label: 'Es grupal' },
    { key: 'firma_por_plantilla', label: 'Es plantilla' },
    { key: 'plantilla_nombre', label: 'Plantilla' },
    { key: 'notificacion_firmantes', label: 'Notificación' },
    { key: 'createdAt', label: 'Fecha creación' },
    { key: 'updatedAt', label: 'última actualización' },
  ];

  // Definición de las acciones personalizadas
  customActions: TableAction[] = [];

  constructor(
    private loteService: LoteService,
    private fb: FormBuilder,
    private authService: AuthService,
    private modalService: NgbModal,
    private downloadService: DownloadService,
    private route: ActivatedRoute,
  ) { }

  async ngOnInit() {

    this.formSearch = this.fb.group({
      search: new FormControl('', [])
    });

    this.route.paramMap
      .pipe(takeUntil(this.destroy$)) // Desuscribe automáticamente al destruir el componente
      .subscribe(async params => {
        // 'id' es el nombre del parámetro definido en tu configuración de rutas
        // Por ejemplo: path: 'firmas/firma/:id'
        const id = params.get('id');
        
        if (id) {
          this.idLoteCompleto = id;
        } else {
          this.idLoteCompleto = '';
        }


      });


    this.customActions = [
      {
        label: 'Editar',
        handler: (item: Item) => {
          this.onDocumentoClick(item)
        },
        icon: 'fa-solid fa-pen-to-square',
        colorClass: 'bg-orange',
      },
      {
        label: 'Descargar',
        handler: (item: Item) => this.descargarDocumento(item),
        icon: 'fa-solid fa-download',
        colorClass: 'bg-green'
      },
    ];

    this.userToken = localStorage.getItem(k.token);
    if (this.userToken) {
      const dataUser = await this.authService.dataUser(this.userToken);
      this.userId = dataUser.id;
      await this.getLotesCompletados();
    }
  }

  async clickSearch() {
    this.currentPage = 1;
    this.getLotesCompletados();
  }


  async getLotesCompletados() {
    const { search } = this.formSearch.value;
    let data = await lastValueFrom(this.loteService.getLotes(
      this.currentPage
      , this.pageSize, this.userId, 'COMP', search, this.idLoteCompleto))


    const headers: HttpHeaders = data.headers;         

    this.currentItems = data.body.map((x: any) => {
      return {
        id: x.id,
        createdAt: this.formatDate(x.createdAt),
        updatedAt: this.formatDate(x.updatedAt),
        titulo: x.titulo,
        total_documentos: x.total_documentos,
        es_grupo: (x.es_grupo ? 'Si' : 'No'),
        estado: x.estado.nombre,
        firma_por_plantilla: (x.firma_por_plantilla ? 'Si' : 'No'),
        notificacion_firmantes: (x.notificacion_firmantes ? 'Si' : 'No'),
        plantilla_nombre: (x?.plantilla?.nombre),
        usuario: (x?.usuario?.firstName + ' ' + x?.usuario?.lastName)
      }
    });
    this.totalItems = Number(headers.get('X-Total-Count'));
  }


  async onPageChange(newPage: number) {
    this.currentPage = newPage;
    await this.getLotesCompletados();
  }

  async onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
    this.currentPage = 1; // Siempre vuelve a la primera página al cambiar el tamaño      
    await this.getLotesCompletados();
  }


  formatDate(dateStr: string): string {
    if (!dateStr) return '';

    const date = new Date(dateStr);

    return new Intl.DateTimeFormat('es-SV', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true, // false si quieres 24h
    }).format(date);
  }


  onDocumentoClick(itemLote: any) {
    this.loteSelected = itemLote;
    this.openModal(this.modalDescargaDocumento);
  }


  openModal(content: any) {
    const modalRef = this.modalService.open(content, {
      centered: true,
      size: 'lg',
    });



    modalRef.result
      .then((result) => {
        // cierre normal (modal.close)    
      })
      .catch((reason) => {
        // cerrado con X, ESC o backdrop        
      });
  }


  async descargarZipPorLote(id: any, nameZip: string) {

    this.downloadService
      .descargarZipPorLote(id, 'mis_documentos')
      .subscribe((blob: Blob) => {
        const fileName = `${nameZip}.zip`; // o el que quieras
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(objectUrl);
      });


  }


  async descargarZipLotePorGrupo(id: any, usuarioId: number, nameZip: string) {

    this.downloadService
      .descargarZipLotePorGrupo(id, usuarioId,)
      .subscribe((blob: Blob) => {
        const fileName = `${nameZip}.zip`; // o el que quieras
        const a = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(objectUrl);
      });


  }

  descargarDocumento(item: any) {
    
    if (item.es_grupo == 'No') {
      this.descargarZipPorLote(item.id, item.titulo);
    } else {
      this.descargarZipLotePorGrupo(item.id, this.userId, item.titulo);
    }
  }

}